"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hr = exports.Colours = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var Colours;
(function (Colours) {
    Colours["GRAY_200"] = "gray-200";
    Colours["GRAY_400"] = "gray-400";
})(Colours = exports.Colours || (exports.Colours = {}));
var Hr = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("horizontal")
        .pmod(props.colour || Colours.GRAY_200)
        .bem;
    return ((0, jsx_runtime_1.jsx)("hr", __assign({}, props, { className: "".concat(cls, " ").concat(props.className || "") })));
};
exports.Hr = Hr;
